"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 15 15';

var CheckboxOff = function CheckboxOff() {
  return _react["default"].createElement("path", {
    d: "M1.9495,0.5 C1.1485,0.5 0.5,1.1495 0.5,1.9495 L0.5,13.3255 C0.5,14.1265 1.1485,14.7755 1.9495,14.7755 L13.325,14.7755 C14.126,14.7755 14.775,14.1265 14.775,13.3255 L14.775,1.9495 C14.775,1.1495 14.126,0.5 13.325,0.5 L1.9495,0.5 Z M13.66,1.9495 L13.66,13.3255 C13.66,13.5105 13.5095,13.66 13.325,13.66 L1.9495,13.66 C1.765,13.66 1.615,13.5105 1.615,13.3255 L1.615,1.9495 C1.615,1.7655 1.765,1.615 1.9495,1.615 L13.325,1.615 C13.5095,1.615 13.66,1.7655 13.66,1.9495 Z"
  });
};

var svgProps = {
  color: _styles.colors.gray,
  viewBox: viewBox
};

var _default = (0, _createSvgIcon["default"])(CheckboxOff, svgProps);

exports["default"] = _default;